module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_7.566353c2.png";